import { forwardRef, type ReactNode } from "react";
import { Stack, type StackProps } from "@mui/material";

export type SectionContentProps = StackProps & {
    children: ReactNode;
};

/** Shared 24 px section body geometry from the Entity form Figma surfaces. */
export const SectionContent = forwardRef<HTMLDivElement, SectionContentProps>((props, ref) => {
    const { children, sx, ...rest } = props;

    return (
        <Stack ref={ref} gap={3} padding={3} sx={sx} {...rest}>
            {children}
        </Stack>
    );
});

SectionContent.displayName = "SectionContent";
